import { render, staticRenderFns } from "./HelpPagesIndexComponent.vue?vue&type=template&id=019ef270"
import script from "./HelpPagesIndexComponent.vue?vue&type=script&lang=js"
export * from "./HelpPagesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports